<vnext-page-spinner
  [loaderText]="loaderText"
  [loaderIcon]="loaderIcon"
  [showLoaderMessage]="showLoaderMessage"
>
</vnext-page-spinner>
<div class="vnext-app">
  <router-outlet></router-outlet>
</div>
